import api from '../api/axios';
import { VoiceEntity } from '../types/entities';

const BASE = process.env.REACT_APP_BASE_API_URL || process.env.REACT_APP_API_URL || '';
const withBase = (path: string) => `${BASE}${path}`;

export const getActiveVoices = async () => {
  const res = await api.get(withBase(`/voices/active`));
  return res.data as VoiceEntity[];
};

export const getVoices = async () => {
  const res = await api.get(withBase(`/voices`));
  return res.data as VoiceEntity[];
};

export type VoiceCreateRequest = {
  name: string;
  gender: 'man' | 'woman';
  provider?: string | null;
  externalVoiceId?: string | null;
  languageCode?: string | null;
  description?: string | null;
  sampleAudioPath?: string | null;
  isActive?: boolean;
};

export const createVoice = async (payload: VoiceCreateRequest) => {
  const res = await api.post(withBase(`/voices`), payload);
  return res.data as VoiceEntity;
};

export const updateVoice = async (id: string, payload: Partial<VoiceCreateRequest>) => {
  const res = await api.patch(withBase(`/voices/${id}`), payload);
  return res.data as VoiceEntity;
};

export const deleteVoice = async (id: string) => {
  const res = await api.delete(withBase(`/voices/${id}`));
  return res.data as { success?: boolean } | any;
};

export type ElevenLabsVoice = {
  id: string;
  name: string;
};

export const getElevenLabsVoices = async () => {
  const res = await api.get(withBase(`/elevenlabs/voices`));
  return res.data as ElevenLabsVoice[];
};

export type VoiceTtsExampleRequest = {
  id?: string;
  voiceId: string;
  text: string;
  languageCode: string;
};

export const postVoiceTtsExample = async (payload: VoiceTtsExampleRequest) => {
  const res = await api.post(withBase(`/voices/tts-example`), payload);
  return res.data as VoiceEntity; // server returns the updated/replaced VoiceEntity
};

const voiceService = {
  getActiveVoices,
  getVoices,
  createVoice,
  updateVoice,
  deleteVoice,
  getElevenLabsVoices,
  postVoiceTtsExample,
};

export default voiceService;
